import Box from '@mui/material/Box';

import useStyles from './ActionWrapper.styles';

const ActionWrapper = ({
  children,
  action
}: {
  children: React.ReactNode;
  action?: () => void;
}) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.actionWrapper} onClick={() => action?.()}>
      {children}
    </Box>
  );
};

export default ActionWrapper;
